// extracted by mini-css-extract-plugin
module.exports = {"title":"NwsZ","list":"_0iV1","informationText":"WtPf","buddiesCardsContainer":"_-33Y"};